import { useCallback } from 'react';
import { SubmitHandler, UseFormReturn } from 'react-hook-form';

import { useDebounceCallback } from 'usehooks-ts';

import { POLL_SAVE_DEBOUNCE_TIME } from '../../../constants';
import { FormValues } from '../../PollTitleForm/types';

export interface UseUnpublishedPollTitle {
  formMethods: UseFormReturn<FormValues>;
  onSubmit: SubmitHandler<FormValues>;
  onLocalSubmit: SubmitHandler<FormValues>;
}

const useUnpublishedPollTitle = ({ formMethods, onSubmit, onLocalSubmit }: UseUnpublishedPollTitle) => {
  const { handleSubmit } = formMethods;

  const onChange = useCallback(() => {
    handleSubmit(onSubmit)();
  }, [handleSubmit, onSubmit]);

  const handleChange = useDebounceCallback(onChange, POLL_SAVE_DEBOUNCE_TIME);

  const handleBlur = useCallback(() => {
    handleSubmit(onLocalSubmit)();
  }, [handleSubmit, onLocalSubmit]);

  return { handleChange, handleBlur };
};

export default useUnpublishedPollTitle;
